import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  height: 100vh;

  display: grid;
  grid-template-rows: auto 1fr;
`

export const HeaderDesktop = styled.header`
  display: none;

  ${mediaQueries.tablet} {
    display: flex;
  }

  padding: var(--space-300) var(--space-300) var(--space-400);
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-primary);

  flex-direction: column;
  align-items: center;

  position: relative;

  color: var(--text-primary);

  h6 {
    color: inherit;
  }
`

export const HeaderLogo = styled.div`
  position: absolute;
  left: var(--space-300);
  top: var(--space-250);
`

export const Headline = styled.div`
  display: flex;
  gap: var(--space-200);
  align-items: center;

  h4 {
    display: flex;
    gap: var(--space-200);
    font-size: var(--font-size-600);
    line-height: var(--font-line-height-600);
  }
`

export const HeaderButtons = styled.div`
  margin-top: var(--space-200);

  display: flex;
  justify-content: center;
`

export const PreviewIframe = styled.iframe`
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
`

export const HeaderMobile = styled.header`
  display: flex;
  flex-direction: column;
  padding: var(--space-500);
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-primary);
  color: var(--text-primary);

  ${mediaQueries.tablet} {
    display: none;
  }
`

export const MobileTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--space-300);
`

export const MobileHeadline = styled.div`
  margin-bottom: var(--space-300);

  font-size: var(--font-size-400);
  line-height: var(--font-line-height-400);
  font-weight: var(--font-weight-semibold);
  color: inherit;
`

export const MobileButtons = styled.div`
  > div {
    display: flex;
    gap: var(--space-150);

    > button {
      flex: 1;
    }

    > a {
      flex: 1;
    }
  }
`
